export default __webpack_public_path__ + "static/media/include_1@2x.5b5af7c0.jpg";